import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownBar() {
  const [totalSeconds, setTotalSeconds] = useState(15 * 60); // 15 minutes
  useEffect(() => {
    if (totalSeconds <= 0) return;
    const interval = setInterval(() => {
      setTotalSeconds(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <a href="https://maestros.ebookditales.com/cart/44768212975752:1" target="_blank" rel="noopener noreferrer" className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2.5 px-4 flex items-center justify-center gap-3 shadow-md cursor-pointer no-underline" data-id="element-14">
      <ClockIcon className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-15" />
      <span className="text-xs md:text-sm font-semibold" data-id="element-16">
        ¡Oferta especial termina en
      </span>
      <span className="font-mono font-bold text-sm md:text-lg bg-red-800 px-2 py-0.5 rounded" data-id="element-17">
        {pad(minutes)}:{pad(seconds)}
      </span>
      <span className="text-xs md:text-sm font-semibold hidden sm:inline" data-id="element-18">
        — ¡Aprovechá ahora!
      </span>
    </a>;
}